module.exports = __webpack_public_path__ + "img/HelveticaNeueMediumTeal.3c3f284a.png";